/**
 * 搜索失败时渲染
 */

import React from 'react';
import { Menu } from '@cainiaofe/cn-ui';
export default (function (props) {
  var prefix = props.prefix,
    locale = props.locale;
  return /*#__PURE__*/React.createElement(Menu, {
    className: prefix + "cascader-select-not-found"
  }, /*#__PURE__*/React.createElement(Menu.Item, null, /*#__PURE__*/React.createElement("div", {
    className: "cn-address--search-failed-container cn-address-search-text",
    title: locale.searchFailed
  }, locale.searchFailed)));
});